import React, { useEffect } from 'react';
import { useAppDispatch } from '../../core/utils';
import { setBodyTypeLabels } from '../../core/reducers/ui';
import VehicleListFilters from './VehicleListFilters';
import { createObjectFromProps } from '../../utils/object';
import { getBodyTypeFiltersFromProps, getProps } from './service/utils';
import useInventoryFilterOptionsList from './hooks/useInventoryFilterOptionsList';
import useYearFilterPreSelect from './hooks/useYearFilterPreSelect';
import useFilterGtm from './hooks/useFilterGtm';
const VehicleListFiltersMap = ({ fields, rendering }) => {
    var _a;
    const dispatch = useAppDispatch();
    const inventoryFilterOptions = useInventoryFilterOptionsList();
    const simplifiedFields = createObjectFromProps((_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value);
    const props = getProps(simplifiedFields);
    // add body type filters and their user-facing labels to ui.state, for use by other modules
    const bodyTypeFilters = getBodyTypeFiltersFromProps(props);
    useEffect(() => {
        if (bodyTypeFilters) {
            dispatch(setBodyTypeLabels(bodyTypeFilters));
        }
    }, [bodyTypeFilters, dispatch]);
    //  filter gtm event
    useFilterGtm();
    // FIXME: Currently, we render availability statuses if there are no filter options in Sitecore.
    // Instead, we'd like a variant param on the Sitecore component.
    const filterOptionsListFromSitecore = props.filterOptionsList;
    const isInventoryVariant = !(Array.isArray(filterOptionsListFromSitecore) && filterOptionsListFromSitecore.length);
    // Inventory filter - pre select model year
    useYearFilterPreSelect(isInventoryVariant);
    const filterOptionsList = isInventoryVariant ? inventoryFilterOptions : filterOptionsListFromSitecore;
    if ((filterOptionsList === null || filterOptionsList === void 0 ? void 0 : filterOptionsList.length) === 0) {
        return null;
    }
    return (React.createElement(VehicleListFilters, { componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName, filterOptionsList: filterOptionsList, isInventoryVariant: isInventoryVariant }));
};
export default VehicleListFiltersMap;
